import { FSCollections } from '@src/constants/database';
import ScheduleTemplateRepository from '@src/repositories/ScheduleTemplateRepository';

import { buildTextSearch } from './utils';

class ScheduleTemplateService {
  constructor() {
    this.repository = new ScheduleTemplateRepository();
  }

  /**
   * Get a schedule template by organization, division and template id
   * @param {string} orgId - Organization ID
   * @param {string} divId - Division ID
   * @param {string} templateId - Template ID
   * @returns {Promise<ScheduleTemplate>} Schedule template
   */
  async get(orgId, divId, templateId) {
    return await this.repository.get(orgId, divId, templateId);
  }

  /**
   * Search schedule templates in Elasticsearch
   * @param {string} orgId - Organization ID
   * @param {string[]} divsIds - Division IDs
   * @param {number} pageSize - Number of templates per page
   * @param {number} from - Starting position for pagination
   * @param {string} searchTerm - Search term to filter templates
   * @param {string[]} ids - Template IDs to filter by
   * @param {boolean} exactMatch - Whether to match exactly or partially
   * @returns {Promise<{templates: Array, total: number}>}
   */
  async searchElastic({
    orgId,
    divsIds = [],
    pageSize = 10,
    from = 0,
    searchTerm = '',
    ids = [],
    exactMatch = false,
  }) {

    if (!orgId) {
      throw new Error('Organization ID is required');
    }

    const sort = [{ field: 'createdAt._seconds', order: 'desc' }];
    const pagination = { from, size: pageSize };
    const filters = {};
    if (searchTerm) filters.textSearch = buildTextSearch(searchTerm, exactMatch);
    if (ids?.length > 0) filters.terms = { id: ids };

    const params = {
      entity: FSCollections.SCHEDULE_TEMPLATES,
      organizationId: orgId,
      divisionIds: divsIds,
      filters,
      pagination,
      sort,
    };

    return await this.repository.listElastic(params);
  }
}

export default ScheduleTemplateService;
